/**
 * Class Name Utility - combines clsx and tailwind-merge
 *
 * Use this utility for merging Tailwind CSS class names safely.
 * It handles conditional classes and resolves Tailwind conflicts.
 *
 * Extended with OwnYou custom font sizes so tailwind-merge recognizes
 * text-display, text-heading, etc. as fontSize utilities (not colors).
 *
 * @example
 * cn('px-2 py-1', isActive && 'bg-blue-500', 'px-4')
 * // => 'py-1 bg-blue-500 px-4' (px-4 overrides px-2)
 */
import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                { text: ['display', 'heading', 'subhead', 'body', 'caption', 'small'] },
            ],
        },
    },
});
/**
 * Merge class names with Tailwind conflict resolution
 * @param inputs - Class values to merge (strings, arrays, objects, conditionals)
 * @returns Merged and deduplicated class string
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map